import React from "react";
import "./Header.scss";
import { useNavigate, useLocation } from "react-router-dom";
import Home from "../Icons/Home";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();

  function routeToHome() {
    navigate("/");
  }

  return (
    <>
      {location.pathname != "/" && (
        <header>
          <img
            onClick={() => routeToHome()}
            className="logo"
            src="/images/logo.svg"
            alt="header logo"
          />
          {location.pathname != "/" && (
            <div className="homeBtn" onClick={() => routeToHome()}>
              <Home />
            </div>
          )}
        </header>
      )}
    </>
  );
}

export default Header;
